<template>
  <div
    :id="formName + '-form'"
    :class="'woocommerce-' + formName + '-fields'"
  >
    <div id="registration-form-errors">
      <div
        v-show="hasErrors"
        class="registration-form-errors woocommerce-error"
      >
        {{ $modeoL10n.errors_in_form }}
      </div>
    </div>

    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="serverErrorMessage"
      v-html="$sanitize(serverErrorMessage)"
    />
    <!-- eslint-enable vue/no-v-html -->

    <div :class="'woocommerce-' + formName +'-fields__field-wrapper'">
      <div
        v-for="(field,key) in formFields"
        :id="key + '_field'"
        :key="key"
        class="form-row"
        :class="field.class.join(' ')"
      >
        <label
          :for="key"
          :class="{'form-label-has-error': errors.has(key) }"
        >{{ field.label }}
          <abbr
            v-if="field.required"
            title="vaaditaan"
            class="required"
          >*</abbr>
        </label>

        <template v-if="field.type == 'country'">
          <strong>{{ $modeoL10n.finland }}</strong>
          <input
            :id="key"
            type="hidden"
            :name="key"
            value="FI"
          >
        </template>

        <input
          v-if="field.type != 'country'"
          :id="key"
          v-model="address[getIndex(key)]"
          v-validate="getValidations(field, key)"
          :type="getType(field)"
          :name="key"
          placeholder=""
          :autocomplete="field.autocomplete"
          class="input-text"
          :disabled="key == formName + '_country'"
          :class="{'form-field-has-error': errors.has(key) }"
          @change="formChanged()"
          @blur="fieldFocusOut(key)"
        >

        <span
          v-if="errors.has(key)"
          class="form-field-error-message"
        >{{ errors.first(key) }}</span>
      </div>
    </div>

    <div class="form-footer">
      <input
        id="woocommerce-register-nonce"
        type="hidden"
        name="woocommerce-register-nonce"
        :value="nonce"
      >
      <input
        type="hidden"
        name="_wp_http_referer"
        value="/rekisteroidy/"
      >
      <input
        type="submit"
        name="register"
        :value="$modeoL10n.register"
        class="woocommerce-Button button btn btn--block"
        @click="submit($event)"
      >

      <p class="form-disclaimer">
        {{ $modeoL10n.asterisk_explanation }}
      </p>

      <p class="form-footer__link">
        {{ $modeoL10n.already_an_account }} <a :href="$modeoL10n.url_myaccount">{{ $modeoL10n.log_in }}!</a>
      </p>
    </div>
  </div>
</template>

<script>
    import _ from 'lodash';
    /* TODO: Country hardcoded to FI */

    export default {
        props: {
            defaultValues: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            formFields: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            nonce: {
                type: String,
                default: '',
            },
            defaultErrorMessage: {
                type: String,
                default: '',
            },
        },
        data : function () {
            return {
                formName: 'registration',
                address: {},
                useShippingAddress: false,
                formValidated: false,
                register: false,
                password: "",
                submitClicked: false,
            };
        },
        computed: {
            serverErrorMessage: function() {
                if ((this.submitClicked && !this.isFormValid) || this.isFormTouched) {
                    return false;
                } else {
                    return this.defaultErrorMessage;
                }
            },
            isFormValid: function () {
                return _.keys( this.fields ).every( key => this.fields[ key ].valid );
            },

            hasErrors: function () {
                return _.keys( this.fields ).some( key => !this.fields[ key ].valid && this.fields[ key ].touched );
            },

            isFormTouched: function() {
                return _.keys(this.fields).some(key => this.fields[key].touched);
            },
        },
        created: function () {
            if (!_.isEmpty( this.defaultValues )) {
                this.address = this.defaultValues;
            }
            this.formChanged();
        },
        methods: {
            getType(field) {
                if (typeof field.type !== 'undefined') {
                    return field.type;
                } else {
                    return 'text';
                }
            },
            getIndex(index) {
                return index.replace(this.formName + "_", '');
            },
            formChanged() {

            },
            fieldFocusOut( key ) {
                this.$validator.validate( key );
            },
            getValidations(field, key) {
                let validations = [];
                if (field.required) {
                    validations.push('required');
                }
                if (field.type == 'email') {
                    validations.push('email');
                }
                if ( key == 'billing_company_id' ) {
                    validations.push( 'businessid' );
                }
                if (field.type == 'tel') {
                    validations.push('phone-fi');
                }

                return validations.join('|');
            },
            validate() {
                this.$validator.validate();
            },

            submit($event) {
                if (!this.isFormValid) {
                    this.$validator.validate();
                    $event.preventDefault();
                    this.submitClicked = true;

                    //Scroll to errors
                    var formErrorsTop = document.getElementById("registration-form-errors").offsetTop;
                    window.scrollTo( 0, formErrorsTop - 30);
                }
            },
        },
    }
</script>
